import http from '../../vue-config/axios'

import { getBaseApiURL, authApiURL, printerApiURL } from '../../utils'

const getTravelDocument = ({ type = 'Voucher', item, booking }) => {
  const action = 'get' + type
  return http.get(authApiURL, { params: { action, pdf: true, booking, item } })
    .then(data => data.data.pdf)
}

const getCustomPdf = ({ html }) => {
  return http
    .post(
      printerApiURL,
      { html_body: html },
      { params: { pdf: true }, responseType: 'arraybuffer' }
    )
    .then(res => {
      return res.data
    })
}

const getReceipt = ({ bookingId, receiptId }) => {
  const params = {
    action: 'getReceipt',
    booking: '' + bookingId,
    id: '' + receiptId
  }
  return http.get(authApiURL, { params: params }).then(res => res.data)
}

const getInvoice = ({ bookingId, invoiceId }) => {
  const params = {
    action: 'getInvoice',
    booking: '' + bookingId,
    id: '' + invoiceId
  }
  return http.get(authApiURL, { params: params }).then(res => res.data)
}

const getEurolifeDocument = ({ type = 'policy', item, booking }) => {
  const action = 'getEurolifeDocument'
  return http.get(authApiURL, { params: { action, pdf: true, type, booking, item } })
    .then(data => data.data.pdf)
}

const openPrintPage = ({ html }) => {
  const url = getBaseApiURL() + printerApiURL
  const frm = document.createElement('form')
  frm.setAttribute('action', url)
  frm.setAttribute('method', 'post')
  frm.setAttribute('target', '_blank')
  const input = document.createElement('input')
  input.setAttribute('type', 'hidden')
  input.setAttribute('name', 'html_body')
  input.setAttribute('value', html)
  frm.appendChild(input)
  document.body.appendChild(frm)
  setTimeout(function () {
    frm.submit()
    frm.remove()
  }, null)
}

const downloadPdf = ({ pdfData, fileName, dataType = 'base64' }) => {
  const downloadLink = document.createElement('a')
  let url
  if (dataType === 'base64') url = 'data:application/pdf;base64,' + pdfData
  else {
    const blob = new Blob([pdfData], { type: 'application/pdf' })
    url = window.URL.createObjectURL(blob)
  }
  downloadLink.setAttribute('href', url)
  downloadLink.setAttribute('download', fileName)
  downloadLink.setAttribute('target', '_blank')
  document.body.appendChild(downloadLink)
  setTimeout(function () {
    downloadLink.click()
    downloadLink.remove()
  }, null)
}

export {
  getCustomPdf,
  getTravelDocument,
  openPrintPage,
  downloadPdf,
  getReceipt,
  getInvoice,
  getEurolifeDocument
}
